'use client';
import { useEffect, useRef } from 'react';

import { SubHeadline } from '~components/Typography';
import { useSession } from '~hooks/useSession';
import { useTranslations } from '~i18n/hooks';
import { generationApi } from '~services/api/generation';
import { ButtonStroked } from '~shared/ui/atoms/Buttons/ButtonStroked';
import { Loader } from '~shared/ui/atoms/Loader';
import { ErrorWrapper } from '~widgets/BotWizard/ui/BotWizard/styles';

import { botWizardConfig } from './model/botWizardConfig';
import { mapper } from './model/mapper';
import { BotWizard as Wizard } from './ui/BotWizard';

export const BotWizard = () => {
	// idk how to force next respect (scroll: false)
	const ref = useRef<
		((arg?: boolean | ScrollIntoViewOptions | undefined) => void) | null
	>(null);

	const { userId } = useSession();
	const t = useTranslations('BotWizard');

	const { data, isError } = generationApi.useGetBotWizardSettingsQuery(
		undefined,
		{
			selectFromResult: (data) => {
				return {
					...data,
					data: data.data
						? mapper(
								botWizardConfig,
								data.data.generationSettings,
								t.raw('previewStepBlocks'),
								t.raw('fields')
						  )
						: null,
				};
			},
			skip: !userId,
		}
	);

	useEffect(() => {
		ref.current = Element.prototype.scrollIntoView;
		Element.prototype.scrollIntoView = () => null;

		return () => {
			Element.prototype.scrollIntoView = ref.current!;
		};
	}, []);

	if (data) {
		return <Wizard {...data} />;
	}

	if (isError) {
		return (
			<ErrorWrapper>
				<SubHeadline>Failed to initialize character generation</SubHeadline>
				<ButtonStroked
					size="L"
					forceNativeLink={true}
					target="_self"
					href={window.location.pathname}
				>
					Try again
				</ButtonStroked>
			</ErrorWrapper>
		);
	}
	return <Loader />;
};
